import { COD_RETAIL_CONFIGURATION } from "@/app/infrastructures/misc/RolePermission";
import { FlagsCodConfiguration } from "@/feature-flags/flags-cod-configuration";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const DetailCODRetailConfiguration = () =>
  import(
    /* webpackChunkName: "CODRetailConfig" */ "@/app/ui/views/pricing/cod-retail-configuration/component/detail.vue"
  );
const EditCODRetailConfiguration = () =>
  import(
    /* webpackChunkName: "CODRetailConfig" */ "@/app/ui/views/pricing/cod-retail-configuration/component/edit-domestic.vue"
  );
const DetailCODInternationalConfiguration = () =>
  import(
    /* webpackChunkName: "CODInternationalConfig" */ "@/app/ui/views/pricing/cod-retail-configuration/component/detail-international.vue"
  );
const EditCODInternationalConfiguration = () =>
  import(
    /* webpackChunkName: "CODInternationalConfig" */ "@/app/ui/views/pricing/cod-retail-configuration/edit-international.vue"
  );

export default [
  {
    path: "/tarif/konfigurasi-cod-retail",
    component: Layout,
    name: "cod-retail-configuration-detail",
    meta: {
      title: "Konfigurasi COD | Detail",
      hidden: true,
      parent: "Konfigurasi COD",
      permission: COD_RETAIL_CONFIGURATION.DETAIL
    },
    children: [
      {
        path: ":id",
        name: "detail-cod-retail-configuration",
        component: DetailCODRetailConfiguration,
        meta: {
          header: true,
          isAuth: true
        }
      }
    ]
  },
  {
    path: "/tarif/konfigurasi-cod-retail",
    component: Layout,
    name: "cod-retail-configuration-edit",
    meta: {
      title: "Konfigurasi COD | Edit",
      hidden: true,
      parent: "Konfigurasi COD",
      permission: COD_RETAIL_CONFIGURATION.EDIT
    },
    children: [
      {
        path: ":id/edit",
        name: "edit-cod-retail-configuration",
        component: EditCODRetailConfiguration,
        meta: {
          header: true,
          title: "Konfigurasi COD | Edit",
          name: "Ubah COD Retail",
          before: "/tarif/cod/:id",
          isAuth: true
        }
      }
    ]
  },
  {
    path: "/tarif/konfigurasi-cod-international",
    component: Layout,
    name: "cod-international-configuration-edit",
    meta: {
      title: "Konfigurasi COD | Edit",
      hidden: true,
      parent: "Konfigurasi COD",
      "parent-path": "/tarif/konfigurasi-cod-retail",
      permission:
        FlagsCodConfiguration.permission_redirect_cod_international_configuration_edit
    },
    children: [
      {
        path: ":id/edit",
        name: "edit-cod-international-configuration",
        component: EditCODInternationalConfiguration,
        meta: {
          header: true,
          title: "Konfigurasi COD | Edit",
          name: "Ubah COD International Klien",
          before: "/tarif/konfigurasi-cod-international/:id",
          isAuth: true,
          noPaddingWithBreadcrumbV2: true,
          newLayout: true,
        }
      }
    ]
  },
  {
    path: "/tarif/konfigurasi-cod-international",
    component: Layout,
    name: "cod-international-configuration-detail",
    meta: {
      hidden: true,
      parent: "Konfigurasi COD",
      permission: COD_RETAIL_CONFIGURATION.DETAIL,
      noPaddingWithBreadcrumbV2: true,
      newLayout: true,
      "parent-path": "/tarif/konfigurasi-cod-retail",
    },
    children: [
      {
        path: ":id",
        name: "detail-cod-international-configuration",
        component: DetailCODInternationalConfiguration,
        meta: {
          "parent-path": "/tarif/konfigurasi-cod-retail",
          header: true,
          isAuth: true,
          noPaddingWithBreadcrumbV2: true,
          newLayout: true,
        }
      }
    ]
  },
];
